import {LocationDtoWithId, UserId} from '../common/models';

export function isModeratorOrOwner(x: LocationDtoWithId, userId: UserId | undefined) {
  if (!userId) return false;
  return (x.owner !== 'deleted' && x.owner.id === userId) || !!x.moderators.find((m) => m.id === userId);
}
